import { render } from "./NewsItem.vue?vue&type=template&id=aa39cdc2&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=aa39cdc2&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa39cdc2"]])

export default __exports__